import { render, staticRenderFns } from "./NbBoxes.vue?vue&type=template&id=b63b6204&scoped=true&"
import script from "./NbBoxes.vue?vue&type=script&lang=js&"
export * from "./NbBoxes.vue?vue&type=script&lang=js&"
import style0 from "./NbBoxes.vue?vue&type=style&index=0&id=b63b6204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63b6204",
  null
  
)

export default component.exports